import { NOTIFICATION_SHOW, NOTIFICATION_HIDE } from '../constants/ActionTypes';

export const showNotification = (name) => (dispatch) =>
	dispatch({
		type: NOTIFICATION_SHOW,
		name,
	});

export const hideNotification = (name) => (dispatch) =>
	dispatch({
		type: NOTIFICATION_HIDE,
		name,
	});
